import { Typography, Box } from '@mui/material';
import { MarketSentimentWidget } from '../components/widgets/MarketSentimentWidget';

export default function MarketDrivers() {
  return (
    <>
      {/* Page Header */}
      <Box sx={{ mb: 4 }}>
        <Typography variant="h4" component="h1" fontWeight={700} gutterBottom>
          Market Sentiment Analysis
        </Typography>
        <Typography variant="body1" color="text.secondary">
          AI-powered market sentiment across 4 key categories: Geopolitical, Monetary, Economic, and Market
        </Typography>
      </Box>

      {/* Market Sentiment Widget */}
      <Box sx={{ mb: 3 }}>
        <MarketSentimentWidget />
      </Box>
    </>
  );
}
